import React from 'react';

import { SkeletonLoader } from '@sm/webassets';

const SidebarSkeleton = props => (
  <SkeletonLoader height={200} width={300} {...props}>
    <rect x="0" y="20" rx="0" ry="0" width="182" height="13" />
    <rect x="0" y="53" rx="0" ry="0" width="182" height="13" />
    <rect x="0" y="86" rx="0" ry="0" width="182" height="13" />
  </SkeletonLoader>
);

export default SidebarSkeleton;
